var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Transition',{attrs:{"appear":""}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }